var _path, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInst(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13C1 10.6482 1.00084 8.94693 1.11448 7.61092C1.22706 6.28733 1.44487 5.41431 1.82655 4.70022C2.47919 3.47923 3.47923 2.47919 4.70022 1.82655C5.41431 1.44487 6.28733 1.22706 7.61092 1.11448C8.94693 1.00084 10.6482 1 13 1C15.3518 1 17.0531 1.00084 18.3891 1.11448C19.7127 1.22706 20.5857 1.44487 21.2998 1.82655C22.5208 2.47919 23.5208 3.47923 24.1734 4.70022C24.5551 5.41431 24.7729 6.28733 24.8855 7.61092C24.9992 8.94693 25 10.6482 25 13C25 15.3518 24.9992 17.0531 24.8855 18.3891C24.7729 19.7127 24.5551 20.5857 24.1734 21.2998C23.5208 22.5208 22.5208 23.5208 21.2998 24.1734C20.5857 24.5551 19.7127 24.7729 18.3891 24.8855C17.0531 24.9992 15.3518 25 13 25C10.6482 25 8.94693 24.9992 7.61092 24.8855C6.28733 24.7729 5.41431 24.5551 4.70022 24.1734C3.47923 23.5208 2.47919 22.5208 1.82655 21.2998C1.44487 20.5857 1.22706 19.7127 1.11448 18.3891C1.00084 17.0531 1 15.3518 1 13Z",
    stroke: "#9F9F9F",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 5,
    stroke: "#9F9F9F",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 6,
    r: 1,
    fill: "#9F9F9F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInst);
export default __webpack_public_path__ + "static/media/inst.78c1e33e16733fec49cf13dff6a8c1f5.svg";
export { ForwardRef as ReactComponent };